import {NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { NavigationComponent } from './header/navigation/navigation.component';
import { HttpClientModule } from '@angular/common/http';
import { BFFApiService } from './http/bff-api.service';
import { BFFModule } from '../bff/bff.module';

import { ModalModule } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CookieBannerComponent } from './header/cookie-banner/cookie-banner.component';

@NgModule({
  declarations: [
    FooterComponent,
    NavigationComponent,
    CookieBannerComponent,
  ],
  providers: [
    BFFApiService
  ],
  imports: [
    CommonModule,
    BFFModule,
    HttpClientModule,
    ModalModule.forRoot(), // Move to bootstrap module
    AccordionModule.forRoot(), // Move to bootstrap module
  ],
  exports: [
    FooterComponent,
    NavigationComponent,
    AccordionModule,
    CookieBannerComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class CoreModule { }
